"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var CloseButton_1 = require("../../../gen-src/icons/CloseButton");
var Localize_1 = require("../../../gen-src/Localize");
var ViewerPaneStyles_1 = require("./ViewerPaneStyles");
exports.lineagePanelCloseButtonTestId = 'lineage-panel-close-button';
exports.lineagePanelTitleTestId = 'lineage-panel-title';
var VizClientLineagePaneTitleBar = /** @class */ (function (_super) {
    __extends(VizClientLineagePaneTitleBar, _super);
    function VizClientLineagePaneTitleBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.domRef = React.createRef();
        return _this;
    }
    VizClientLineagePaneTitleBar.prototype.componentDidMount = function () {
        var rootElement = this.domRef.current;
        if (rootElement) {
            // find the element defined as focussable by the tabindex attribute
            var focusableElement = rootElement.querySelector('[tabindex="0"]');
            if (focusableElement) {
                focusableElement.focus();
            }
        }
    };
    VizClientLineagePaneTitleBar.prototype.renderCloseButton = function () {
        if (this.props.onCloseRequested === null) {
            return null;
        }
        return (React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Icon, handleClick: this.props.onCloseRequested, title: Localize_1.Messages.CloseButtonTitle(), testId: exports.lineagePanelCloseButtonTestId, style: { padding: 0 }, getContent: function (buttonState) { return React.createElement(CloseButton_1.SvgCloseButton, null); } }));
    };
    VizClientLineagePaneTitleBar.prototype.render = function () {
        return (React.createElement("div", { ref: this.domRef },
            React.createElement(ViewerPaneStyles_1.TitleBarContainer, null,
                React.createElement("h3", { className: ViewerPaneStyles_1.TitleTextCssClass, "data-tb-test-id": exports.lineagePanelTitleTestId }, this.props.title),
                this.renderCloseButton())));
    };
    return VizClientLineagePaneTitleBar;
}(React.Component));
exports.VizClientLineagePaneTitleBar = VizClientLineagePaneTitleBar;
//# sourceMappingURL=VizClientLineagePanelTitleBar.js.map